import { useCallback, useEffect } from 'react';

/** 拖拽排序开始时禁止选中文字（react-sortable-hoc 等可在 onSortStart 中调用） */
export function beginSortDragUserSelect() {
    document.body.style.userSelect = 'none';
    document.body.style.webkitUserSelect = 'none';
    window.getSelection()?.removeAllRanges();
}

/** 拖拽排序结束时恢复文字选择 */
export function endSortDragUserSelect() {
    document.body.style.userSelect = '';
    document.body.style.webkitUserSelect = '';
}

/** 拖拽排序时禁止选中文字（@dnd-kit 的 onDragStart / onDragEnd / onDragCancel 中使用） */
export default function useSortDragUserSelectChrome() {
    const beginSortDrag = useCallback(() => beginSortDragUserSelect(), []);
    const endSortDrag = useCallback(() => endSortDragUserSelect(), []);

    useEffect(() => () => endSortDrag(), [endSortDrag]);

    return { beginSortDrag, endSortDrag };
}
